import { render, staticRenderFns } from "./CustomChip.vue?vue&type=template&id=5ef5dbbb&scoped=true"
import script from "./CustomChip.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomChip.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CustomChip.vue?vue&type=style&index=0&id=5ef5dbbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef5dbbb",
  null
  
)

export default component.exports